var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 0.900146H5.90039C3.41511 0.900146 1.40039 2.91486 1.40039 5.40014V18.6001C1.40039 21.0854 3.41511 23.1001 5.90039 23.1001H19.1004C21.5857 23.1001 23.6004 21.0854 23.6004 18.6001V12.0001",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 2.12132C18.1499 0.949748 20.0494 0.949748 21.2209 2.12132L22.2816 3.18198C23.4532 4.35355 23.4532 6.25305 22.2816 7.42462L13.1197 16.5866C12.8715 16.8347 12.5443 16.988 12.1948 17.0197L8.69463 17.3379C7.76172 17.4227 6.98017 16.6412 7.06498 15.7083L7.38318 12.2081C7.41495 11.8586 7.56823 11.5314 7.81636 11.2832L16.9783 2.12132Z",
    stroke: "#213332",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.75V3.75C16.4579 6.14467 18.3553 8.04213 20.75 9V9",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit_2.1433fc24d846b24bccbe18f0ebc7ae24.svg";
export { ForwardRef as ReactComponent };